import { type ZodType } from 'zod';

import { ApiError } from './utils/schemas/errors';

export const commonResponses = {
    400: ApiError,
    401: ApiError,
    403: ApiError,
    404: ApiError,
    412: ApiError,
    422: ApiError,
    429: ApiError,
    500: ApiError,
} satisfies Record<number, ZodType>;
